module.exports = __webpack_public_path__ + "static/img/20240927_6.af30ff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2024/20240927_6.png
// module id = CFNu
// module chunks = 0